/* THE SIGN — typografia: sieroty (wiszące spójniki).
   W polskiej typografii jednoliterowy wyraz (a, i, o, u, w, z) nie może kończyć
   wiersza. Podmieniamy spację PO takim wyrazie na niełamliwą, więc przeskakuje
   on do następnej linii razem z wyrazem, do którego należy.

   Dlaczego w JS, a nie w Liquidzie: sieroty siedzą nie tylko w tekstach motywu,
   ale też w nazwach produktów i opisach z katalogu (3883 produkty, importowane),
   a tych nie da się objąć filtrem w szablonie sekcji.

   Skrypt ładowany jest w <head> z `defer`, czyli wykonuje się przed skryptami
   sekcji (kolejność dokumentu) — m.in. zanim karuzela sklonuje karty, więc klony
   dostają już poprawiony tekst. */
(function () {
  'use strict';

  /* Po jednoliterowym wyrazie na początku tekstu albo po spacji / nawiasie /
     cudzysłowie. Wielkie litery też — zdanie może się zaczynać od „W". */
  var SIEROTY = /(^|[\s(\[„"'–—])([aiouwzAIOUWZ])[ \t]+/g;
  var NBSP = ' ';

  /* Elementy, w których tekst nie jest treścią do czytania. */
  var POMIN = {
    SCRIPT: 1, STYLE: 1, TEXTAREA: 1, CODE: 1, PRE: 1, KBD: 1,
    SELECT: 1, OPTION: 1, NOSCRIPT: 1, SVG: 1
  };

  function napraw(korzen) {
    var spacer = document.createTreeWalker(korzen, NodeFilter.SHOW_TEXT, {
      acceptNode: function (wezel) {
        var rodzic = wezel.parentNode;
        if (!rodzic || POMIN[rodzic.nodeName]) return NodeFilter.FILTER_REJECT;
        /* Krótkie teksty bez spacji i tak nie mają gdzie się złamać. */
        if (wezel.nodeValue.indexOf(' ') === -1) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var wezly = [];
    var w;
    while ((w = spacer.nextNode())) wezly.push(w);

    for (var i = 0; i < wezly.length; i += 1) {
      var tekst = wezly[i].nodeValue;
      var nowy = tekst.replace(SIEROTY, '$1$2' + NBSP);
      if (nowy !== tekst) wezly[i].nodeValue = nowy;
    }
  }

  function start() {
    napraw(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Edytor motywu: sekcja przerenderowana = tekst znów z sierotami. */
  document.addEventListener('shopify:section:load', function (event) {
    napraw(event.target);
  });
})();
